export function isGutenbergEditorVisible() {
    return document.body.classList.contains('block-editor-iframe__body')
}

export function locationPathName() {
    return window.location.origin + window.location.pathname
}

export function getUrlWithSerializedForm($form) {
    let permalink = locationPathName();
    let url =  new URL(permalink + '?' + $form.serialize());
    let params = new URLSearchParams(url.search);
    let searchParams = new URLSearchParams(url.search);
    params.delete('action');
    params.delete('is-load-more');
    params.delete('my-page');
    params.delete('posts-not-in');

    searchParams.forEach((value, key) => {
        if( value.length === 0 ) {
            params.delete(key);
        }
    });

    let paramsString = params.toString();

    return ( paramsString ) ? '?' + paramsString : permalink;
}